import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@scotia/canvas-react';
import { TwoColumnCardLayout } from './TwoColundCardLayout';
import customStyles from './DataCard.scss';

const CARD_BACKGROUND_COLOR = {
  WHITE: 'white',
  GRAY: '#FAFBFD'
};

/**A Card used to show the information of an entity instead of a table (Mobile remplacement of table)*/
export const DataCard = props => (
  <Card
    style={props.styles}
    className={
      props.styles &&
      props.styles.backgroundColor &&
      props.styles.backgroundColor === CARD_BACKGROUND_COLOR.GRAY
        ? customStyles['layout-span-background']
        : ''
    }
  >
    <TwoColumnCardLayout title={''}>{props.children}</TwoColumnCardLayout>
  </Card>
);
DataCard.propTypes = {
  /** The data equivalent to a Table row */
  children: PropTypes.node.isRequired,
  /** Styles to be apllied to the Card */
  styles: PropTypes.object
};
